import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {InputTextComponent} from './components/input-text/input-text.component';
import {InputPasswordComponent} from './components/input-password/input-password.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {InputFileComponent} from './components/input-file/input-file.component';
import {AutofocusDirective} from './directives/autofocus.directive';

@NgModule({
  declarations: [
    InputTextComponent,
    InputPasswordComponent,
    InputFileComponent,
    AutofocusDirective
  ],
    exports: [
        InputTextComponent,
        InputPasswordComponent,
        InputFileComponent,
    ],
  imports: [
    ReactiveFormsModule,
    FormsModule,
    CommonModule,
  ]
})
export class InputModule { }
